import { useMap, Marker, Popup, Tooltip} from "react-leaflet";
import { useEffect, useState,useCallback } from "react";
import omnivore from "@mapbox/leaflet-omnivore";
import ApiService from "../../services/apiService";
import ChackComponent from "./ChackComponent";
import { Modal } from "reactstrap";
import L from 'leaflet';
import  MarkerClusterGroup  from 'react-leaflet-cluster';
import { usePagination } from "../../hooks/usePagination";
import RightIcon from "../svg/RightIcon";
import LeftIcon from "../svg/LeftButton";
import ProgressBar from "./ProgressBar";
import ChackOnOf from "./ChackOnOf";
// important for clusters!


const KmLLayer = ({id}:{id:any}) => {
  const map = useMap();
 
  const [chackData, setChackData] = useState<any[]>([]);
  // Add these states at the top of your component
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [kmlUrls, setKmlUrls] = useState([]);
  const[isProgressBar,setIsProgressBar] = useState<boolean>(false);
  const [onlineFilter, setOnlineFilter] = useState<'all' | 'online' | 'offline'>('all');


  const getCustomMarker =(dateTime:any, highlight:boolean = false) =>{
    const apiTime = new Date(String(dateTime).replace(' ', 'T'));
    const currentTime = new Date();
    const diffMilli = currentTime.getTime() - apiTime.getTime();
    const diffHours = diffMilli / (1000 * 60 * 60);
    const color = diffHours > 2 ? '#F7374F' : '#89AC46';
    const className = highlight ? 'circle-marker glow' : 'circle-marker';
    return L.divIcon({
      className: '',
      html: `<div class="${className}" data-color="${color}"></div>`,
      iconSize: [20, 28],
      iconAnchor: [10, 28],
    });

  }
  const {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    setSearchQuery,
    searchQuery,
    filterOn,
    setSortBy
 } = usePagination({
    endpoint: `/chack`,
    enabled:true,
    pageSize:150
 })
 const totalPages = Math.ceil(totalCount / pageSize);
 

 

 useEffect(() => {
  if (!data || data.length === 0) return;

  setIsProgressBar(true);

  // ✅ Append new page data only
  setChackData(prevData => [...prevData, ...data]);

  // ✅ Stop loading when full list is fetched
  if (chackData.length + data.length >= totalCount) {
    const stopTimer = setTimeout(() => {
      setIsProgressBar(false);
    }, 100);
    return () => clearTimeout(stopTimer);
  }

  // ✅ Auto-fetch next page after 1s
  const timer = setTimeout(() => {
    setPageNumber(prev => prev + 1);
  }, 100);

  return () => clearTimeout(timer);
}, [data]);
  
  useEffect(() => {
    const getKml = async () => {
      try {
        const response = await ApiService.axiosApi("/kml", {
          method: "GET",
        });
        if (response.success) {
        
          setKmlUrls(response.data.data);
        } else {
          console.log(response.message || "Unable to get KML data");
        }
      } catch (error: any) {
        console.log(error);
      }
    };

    getKml();
  }, []);
  
 

  useEffect(() => {
    if (kmlUrls.length === 0) return; // If no KML URLs, skip

    // Function to load all KML files onto the map
    const loadKmlLayers = () => {
      kmlUrls.forEach((kmlObj:any) => {
        // Extract filePath from each object
        const kmlUrl = kmlObj.filePath;

        // Check if kmlUrl is a valid string
        if (typeof kmlUrl !== "string") {
          console.error(`Invalid KML URL: ${kmlUrl}`);
          return;
        }

        // Log the URL to ensure it's correct
       

        const kmlLayer = omnivore.kml(kmlUrl).on("ready", () => {
         
          // Get the bounds of the KML layer and fit the map
          const bounds = kmlLayer.getBounds();
          map.fitBounds(bounds); // Adjust the map to fit the KML content
        });

        // Handle error if loading KML fails
        kmlLayer.on("error", (e: any) => {
          console.error("Error loading KML:", e);
        });

        map.addLayer(kmlLayer); // Add the KML layer to the map
      });
    };

    loadKmlLayers();

    // Cleanup layers on component unmount
    return () => {
      kmlUrls.forEach((kmlObj:any) => {
        const kmlUrl = kmlObj.filePath;
        const kmlLayer = omnivore.kml(kmlUrl);
        map.removeLayer(kmlLayer);
      });
    };
  }, [map, kmlUrls]);

  const filterOnlineOffline = (data: any) => {
    if (onlineFilter === 'online') {
      const diff = (new Date().getTime() - new Date(data.dateTime).getTime()) / (1000 * 60 * 60);
      if (diff > 2) return false;
    } else if (onlineFilter === 'offline') {
      const diff = (new Date().getTime() - new Date(data.dateTime).getTime()) / (1000 * 60 * 60);
      if (diff <= 2) return false;
    }
    return true;
  };
  

  return (
    <>
     
     <MarkerClusterGroup>
      {chackData
      .filter(filterOnlineOffline)
      .map((data: any) => (
           
        <Marker key={data.id} position={[data.lat, data.long] }
            
          eventHandlers={{
            click: () => {
              setSelectedId(data.id);
              setIsOpen(true);
            }
          }}
           
          icon={getCustomMarker(data.dateTime, id==data.id)}
        >
            <Tooltip>
               <table className=" table-striped" style={{width:'100%', height:'100%'}}>
                <tbody>
                  <tr> 
                    <th>ChackName</th>
                     <td>{data.chackName}</td>
                  </tr>
                    <tr>
                      <th>Network Strength</th>
                      <td>{data.networkStatus}</td>
                    </tr>
                    <tr>
                      <th>Battery</th>
                      <td>{data.battery}%</td>
                    </tr>
                    <tr>
                      <th>Solar Voltage</th>
                      <td>{data.solarVoltage}V</td>
                    </tr>
                    <tr>
                      <th>Temprature</th>
                      <td>{data.temprature}°C</td>
                    </tr>
                  </tbody>
               </table>
                
            </Tooltip>
            
             
          </Marker>
      ))}
      </MarkerClusterGroup>
      
      {isOpen && selectedId && (
        <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} size="xl" centered>

          <ChackComponent id={selectedId} onClose={() => setIsOpen(false)} />

        </Modal>
      )}
      {/* <div
        style={{
          position: 'absolute',
          top: '40px',
          right: '20px',
          backgroundColor: 'whitesmoke',
          padding: '10px',
          borderRadius: '8px',
          boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
          zIndex: 1000,
        }}
      >
        

      </div> */}

      <div style={{ position: 'absolute', top: '40px', right: '20px', backgroundColor: 'whitesmoke', padding: '10px', borderRadius: '8px', boxShadow: '0px 0px 10px rgba(0,0,0,0.2)', zIndex: 1000 }}>
        <ChackOnOf chackData={chackData} onFilterChange={setOnlineFilter} />
         </div>
          
              
           

          {isProgressBar && <ProgressBar totalpage={totalPages}pageNumber={pageNumber} mystyle={{width:'300px',
            height:'50px',
            position:'absolute',
            bottom:100,
            right:20,
            zIndex:1000,
            backgroundColor:'whitesmoke',
            borderRadius:'4px'}}/>}
    </>
  );
}
export default KmLLayer;
